// wa.me n'accepte que des chiffres dans l'URL (pas de "+", espaces, tirets...).
// Les numeros sont saisis/stockes au format "+224 6XX XX XX XX" donc il faut
// les normaliser, sinon WhatsApp ne peut pas resoudre de contact precis et
// ouvre la liste de discussions a la place d'ouvrir la conversation ciblee.
function normalizePhone(rawPhone: string): string {
  const digits = rawPhone.replace(/\D/g, '');
  if (digits.startsWith('224')) return digits;
  if (digits.startsWith('0')) return `224${digits.slice(1)}`;
  return `224${digits}`;
}

export function buildWhatsAppLink(rawPhone: string, message: string): string {
  const phone = normalizePhone(rawPhone);
  return `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
}
